import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SamplesComponent } from './samples.component';
import { DocumentSamplePageComponent } from './document-sample-page/document-sample-page.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentsModule } from '@app/documents/documents.module';
import { DirectiveModule } from '@app/shared/directive/directive.module';
import { CoreModule } from '@app/core/core.module';
import { PrimeNgModule } from '@app/shared/primeng/prime-ng.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { AttachToAuthComponent } from './attach-to-auth/attach-to-auth.component';
import { AttachToAuthorizationFormComponent } from '@app/features/components/attach-to-authorization-form/attach-to-authorization-form.component';

@NgModule({
  declarations: [
    SamplesComponent,
    DocumentSamplePageComponent,
    AttachToAuthComponent
  ],
  exports: [
    SamplesComponent,
    DocumentSamplePageComponent,
    AttachToAuthComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    PrimeNgModule,
    CoreModule,
    ReactiveFormsModule,
    DirectiveModule,
    DocumentsModule,
    AttachToAuthorizationFormComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SampleModule { }
